import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-digital-signature-rectangle-init',
  templateUrl: './digital-signature-rectangle-init.component.html',
  styleUrls: ['./digital-signature-rectangle-init.component.scss']
})
export class DigitalSignatureRectangleInitComponent implements OnInit {

  constructor(private router: Router) {
  }

  // todo: get it from openkm
  // documentUUID = 'd1dbe1d5-2c46-4536-9f24-138c87d09d28';
  documentUUID = 'e6931c97-d23e-4b33-9827-72582739a8b0';
  fileName = 'document.pdf';

  ngOnInit(): void {
  }

  goToSignatureCreate() {
    this.router.navigate(['/semnatura/signature-rectangle-create', this.documentUUID, this.fileName]);
  }

}
